/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

import styles from "../styles/components/PromptInputs.module.css";
import common from "../styles/Common.module.css";
import useApi from "../hooks/useApi";
import useCharacter from "../hooks/useCharacter";

import Modal from "./Modal";

import uploadIcon from "../images/upload-icon.svg";
import imageIcon from "../images/image-icon.svg";

import { useDispatch } from "react-redux";
import {
  start3DCharacterPolling,
  startCharacterPolling,
} from "../reducers/characterSlice";

// import DropdownAnimation from "./DropdownAnimation";
import DatasetCreator from "./DatasetCreator";
import JSZip from "jszip";
import { addNotification, removeNotification } from "../reducers/notificationsSlice";
import { addModal, closeAllModals, showLoading } from "../reducers/modalsSlice";
import PromptGenerate from "./PromptGenerate";
import PromptCompose from "./PromptCompose";

const AvailableWorkflows = [
  {workflow: 'runpod-2d'}, {workflow: 'playgen-accessory-side'}, {workflow: 'playgen-accessory-front'}, {workflow: 'dr-workflow'}
];

const PromptInputs = ({
  updateMenu,
  variant,
  variant_index,
  prompt,
  externalLoraPrompt,
  startRecording,
  dataset,
  loading,
  recording,
  animations,
  clearDataset,
  character
}) => {
  const { get, post, postFile } = useApi();

  const {
    GenerateFromImage,
    GenerateFromPrompt,
    GenerateFromVRM,
  } = useCharacter();

  const navigate = useNavigate();

  const fileInputRef = useRef(null);
  const vrmInputRef = useRef(null);
  const vrmThumbnailInputRef = useRef(null);

  const [bodies, setBodies] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const [loraPrompt, setLoraPrompt] = useState("");
  const [triggerWord, setTriggerWord] = useState("");
  const [triggerWordError, setTriggerWordError] = useState(false);
  const [selectedControlnet, setSelectedControlnet] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [vrmImageData, setVRMImageData] = useState(null);
  const [vrmFile, setVrmFile] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const getBodies = async () => {
      
      let order = 0;
      let response = [];

      await Promise.all(AvailableWorkflows.map( async element => {
        const r = await get(`/webapp/bodies/?workflow=${element.workflow}`);
        r.forEach(c => {
          response.unshift({...c, order, originalOrder: c.order, workflow: element.workflow});
          order++;
        })
      }))

      setBodies(response);
      if (response.length > 0) {
        setSelectedControlnet(response[0]);
      }
    };

    getBodies();
    return () => {};
  }, []);

  useEffect(() => {
    if (prompt != null) {
      setInputValue(prompt);
    }

    return () => {};
  }, [prompt]);

  useEffect(() => {
    if(updateMenu !== undefined)
      updateMenu(activeTab)
  }, [activeTab, updateMenu])

  const updateTriggerWord = (w) => {
    setTriggerWord(w);
    setTriggerWordError(false);
  }

  const handleGenerateVariants = () => {
    const onCancel = () => {
      dispatch(closeAllModals());
    }
    const onConfirm = async () => {
      dispatch(showLoading());

      let response;
      if(activeTab === 0){
        response = await GenerateFromPrompt(inputValue, selectedControlnet.originalOrder, selectedControlnet.workflow)
      }else{
        response = await GenerateFromImage(imageData.image);
      }
      if(response){
        if (response.id != null) {
          dispatch(startCharacterPolling({ id: response.id, get }));
          navigate(`/character/${response.id}`, { replace: true });
          dispatch(closeAllModals());
        }else{
          dispatch(addModal({ 
            message: response.toString(), 
            type: "confirm",
            onConfirm: onCancel,
          }));		
        }
      }
    }

    dispatch(addModal({ 
      message: "This requires 10 amount of credits. Proceed?", 
      type: "confirm",
      onConfirm: onConfirm
    }));		
  };

  const handleUploadVRM = async () => {
    dispatch(showLoading());
    const response = await GenerateFromVRM(vrmImageData.image, vrmFile);
    dispatch(closeAllModals());

    if('error' in response){
      dispatch(addNotification({message: response['error']}));
      return;
    }
    console.log(response)
    dispatch(start3DCharacterPolling({ id: response.id, get }));
    navigate(`/character/${response.id}`, { replace: true });
  };

  const getDataFromFile = async (file) => {
    return new Promise((resolve)=>{
      const reader = new FileReader();
  
      reader.onloadend = async () => {
        const imageUrl = reader.result;
  
        const blob = await fetch(imageUrl).then((res) => res.blob());
        const newFile = new File([blob], file.name, { type: file.type });
  
        const data = {
          url: imageUrl,
          image: newFile,
          fromInput: true,
        };
        return resolve(data);
      };
      reader.readAsDataURL(file);
    });
  };
  
  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
        const data = await getDataFromFile(file);
        setImageData(data);
    }
  }
  
  const handleVRMImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const data = await getDataFromFile(file);
      setVRMImageData(data);
    }
  };
  
  const handleVRMFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setVrmFile(file);
    }
  }
  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleVRMTuhmbnailClick = () => {
    vrmThumbnailInputRef.current.click();
  };
  const handleVRMClick = () => {
    vrmInputRef.current.click();
  };


  const handleUploadDataset = () => {
    if(triggerWord === ""){
      dispatch(addNotification({ message: "Please enter a trigger word" }));
      setTriggerWordError(true);
      return;
    }
  
    dispatch(addModal({
      type: "confirm",
      message: "This requires 10 amount of credits. Proceed?",
      onConfirm: UploadDataset,

    }))
  };

  const UploadDataset = async () => {
    dispatch(showLoading());
    // Function to convert dataURL to Blob
    function dataURLToBlob(dataURL) {
      const [header, base64] = dataURL.split(',');
      const binary = atob(base64);
      const array = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        array[i] = binary.charCodeAt(i);
      }
      const mime = header.match(/:(.*?);/)[1];
      return new Blob([array], { type: mime });
    }
    
    // Create a ZIP file from dataURLs
    async function createZip(dataURLs) {
      const zip = new JSZip();
  
      // Add each image to the ZIP
      dataURLs.forEach((dataURL, index) => {
        const blob = dataURLToBlob(dataURL);
        zip.file(`image_${index + 1}.png`, blob);
      });
  
      // Generate the ZIP file as a Blob
      return zip.generateAsync({ type: "blob" });
    }

    if(dataset.length > 0){
			let ids = [];
			const zipBlob = await createZip(dataset.map((d) => {
				ids.push(d.animation.id);
				return d.dataURL;
			}));

			try {
				const formData = new FormData();
				formData.append("zip", zipBlob);
				formData.append("ids", JSON.stringify(ids));
				formData.append("variant_id", variant.id);
				formData.append("variant_index", variant_index);
				formData.append("trigger", triggerWord);
			
				const response = await postFile("/webapp/generate/lora/", formData);
				console.log(response);
        
			} catch (error) {
				console.log(error);
			}
			clearDataset();
      dispatch(closeAllModals());
      dispatch(addNotification({message: 'Your model is training, come back later'}))
    }
  };

  return (
    <div className={styles.leftMenu}>
      <div className={styles.tabsContainer}>
        <div className={styles.tabs}>
          <button
            className={`${styles.tab} ${activeTab === 0 && styles.active}`}
            onClick={() => setActiveTab(0)}
          >
            Text
          </button>

          <button
            className={`${styles.tab} ${activeTab === 1 && styles.active}`}
            onClick={() => setActiveTab(1)}
          >
            Image
          </button>
          
          <button
            className={`${styles.tab} ${activeTab === 3 && styles.active}`}
            onClick={() => setActiveTab(3)}
          >
            Upload
          </button>
          <button
            className={`${styles.tab} ${activeTab === 5 && styles.active}`}
            onClick={() => setActiveTab(5)}
          >
            Compose
          </button>

          {character?.has_3d &&
            <button
              className={`${styles.tab} ${activeTab === 2 && styles.active}`}
              onClick={() => setActiveTab(2)}
            >
              Train
            </button>
          }
          {character?.has_lora &&
            <button
              className={`${styles.tab} ${activeTab === 4 && styles.active}`}
              onClick={() => setActiveTab(4)}
            >
              Generate (Lora verion)
            </button>
          }
        </div>

      {/* Prompt */}
        <div
          className={`${styles.tabContent} ${
            activeTab === 0 ? styles.show : styles.hide
          }`}
        >
          <div className={styles.promptContainer}>
            <p className={styles.promptInputTitle}>Prompt</p>

            <textarea
              className={styles.prompt}
              placeholder="Prompt"
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />

            <p>Choose type</p>
            <div className={styles.bodyTypeGrid}>
              {bodies.map((item) => (
                <div
                  key={item.id}
                  className={`${styles.bodyTypeItem}  ${
                    selectedControlnet?.order === item.order ? styles.selected : ""
                  }`}
                  onClick={() => {
                    console.log(item);
                    setSelectedControlnet(item)}}
                >
                  <img src={item.thumbnail}
                    alt={`body ${item.order}`}
                    className={styles.gridImage}
                  />
                </div>
              ))}
            </div>

            <div className={styles.bodyTypesGrid}></div>
          </div>
        </div>

        {/* Image Upload */}
        <div
          className={`${styles.tabContent} ${
            activeTab === 1 ? styles.show : styles.hide
          }`}
        >
          <div className={styles.promptContainer}>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleImageChange}
            />

            <p className={styles.promptTitle}>
              <img src={imageIcon} className={styles.imageIcon} /> Image and
              Prompt
            </p>
            <p className={styles.promptSubtitle}>
              JPG / PNG files up to 10MB with minimun dimension of 300px
            </p>

            <button className={styles.uploadButton} onClick={handleClick}>
              {imageData == null ? (
                <img className={styles.uploadIcon} src={uploadIcon} />
              ) : (
                <img className={styles.customImage} src={imageData.url} />
              )}
            </button>
          </div>
        </div>

        {/* Train */}
        <div
          className={`${styles.tabContent} ${
            activeTab === 2 ? styles.show : styles.hide
          }`}
        >
          <div className={styles.promptContainer}>
            {!loading &&
              <DatasetCreator 
                startRecording={startRecording} 
                clearDataset={clearDataset} 
                dataset={dataset} 
                updateTriggerWord={updateTriggerWord} 
                triggerWordError={triggerWordError} 
                animations={animations} 
                recording={recording}
                loading={loading}/>
            }
          </div>

        </div>
        
        {/* VRM Upload */}
        <div
          className={`${styles.tabContent} ${
            activeTab === 3 ? styles.show : styles.hide
          }`}
        >
          <div className={styles.promptContainer}>
            <input
              type="file"
              accept="image/*"
              ref={vrmThumbnailInputRef}
              style={{ display: "none" }}
              onChange={handleVRMImageChange}
            />

            <p className={styles.promptTitle}>
              <img src={imageIcon} className={styles.imageIcon} /> Thumbnail
            </p>

            <button className={styles.uploadButton} onClick={handleVRMTuhmbnailClick}>
              {vrmImageData == null ? (
                <img className={styles.uploadIcon} src={uploadIcon} />
              ) : (
                <img className={styles.customImage} src={vrmImageData.url} />
              )}
            </button>

            
            <input
              type="file"
              accept=".vrm"
              ref={vrmInputRef}
              style={{ display: "none" }}
              onChange={handleVRMFileChange}
            />
            <p className={styles.promptTitle}>
              <img src={uploadIcon} className={styles.vrmIcon} /> VRM
            </p>
            <button className={styles.uploadButtonSmall} onClick={handleVRMClick}>
              {vrmFile == null ?
                (<>choose a vrm file</>) : 
                (<>{vrmFile.name}</>)
              }
            </button>
          </div>
        </div>

        {/* Generate */}
        <div
          className={`${styles.tabContent} ${
            activeTab === 4 ? styles.show : styles.hide
          }`}
        >
          <div className={styles.promptContainer}>
            <PromptGenerate variant={variant} externalLoraPrompt={externalLoraPrompt}/>
          </div>
        </div>

        {/* Compose */}
        <div
          className={`${styles.tabContent} ${
            activeTab === 5 ? styles.show : styles.hide
          }`}
        >
          <div className={styles.promptContainer}>
            <PromptCompose variant={variant} externalLoraPrompt={externalLoraPrompt}/>
          </div>
        </div>

        {(activeTab === 0 || activeTab === 1) && (
          <button
            className={common.generateButton}
            onClick={handleGenerateVariants}
          >
            Generate (O 10 credits )
          </button>
        )}
        {activeTab === 3 && (
          <button
            className={common.generateButton}
            onClick={handleUploadVRM}
            disabled={!vrmImageData || !vrmFile}
          >
            Upload
          </button>
        )}

        {activeTab === 2 && dataset.length > 0 && (
          <button
            className={common.generateButton}
            onClick={handleUploadDataset}
          >
            Upload Training Data (O 10 credits )
          </button>
        )}

        {/* {menuIndex === 2 && variant.model_vrm !== "" && (
          <DropdownAnimation onSelect={updateAnimation} animations={animations} />
        )} */}

      </div>
    </div>
  );
};

export default PromptInputs;
